import React from 'react';

function Header({ title, content }) {
  return (
    <div className="app-header">
      <h1>{ title || "AI Diamond Painting Creator" }</h1>
      <p dangerouslySetInnerHTML={{ __html: content || "Wir erstellen dein persönliches Wunschmotiv" }}></p>
    </div>
  );
}

export default Header;